// One-off application-fee resolver for a shortlist. Not wired into any page yet (pending reviewed data).
// Unknown never becomes zero; waivers are shown as conditions, never applied automatically.

const FIRST_YEAR_UG = "first_year_undergraduate";

function chargeFor(fee, applicant) {
  const intl = applicant?.residency === "international";
  if (fee.status === "waived") return { amount: 0, min: 0, state: "waived" };
  if (fee.status === "none") return { amount: 0, min: 0, state: "no_fee" };
  if (fee.amount_international != null && !applicant?.residency) {
    return { amount: Math.max(fee.amount, fee.amount_international), min: Math.min(fee.amount, fee.amount_international),
      state: "category_unknown", condition: "Depends on your application category, which isn't recorded" };
  }
  if (intl && fee.amount_international != null) {
    const mayQualify = !!applicant?.enrolled_us_institution && fee.international_note;
    return { amount: fee.amount_international, min: mayQualify ? fee.amount : fee.amount_international,
      state: "charged", condition: mayQualify ? fee.international_note : null };
  }
  return { amount: fee.amount, min: fee.amount, state: "charged" };
}

export function resolveApplicationFees(items, applicant) {
  const charges = new Map();
  const unknown = [];
  for (const it of items || []) {
    const fee = it?.application_fee;
    const applicable = fee && fee.status && fee.applies_to === FIRST_YEAR_UG && it.level === "undergraduate";
    if (!applicable) { unknown.push(it.degree_id); continue; }
    const key = fee.dedupe_key;
    if (charges.has(key)) { charges.get(key).degree_ids.push(it.degree_id); continue; }
    charges.set(key, {
      key, university_id: it.university_id, currency: fee.currency, channel: fee.channel,
      charged_per: fee.charged_per, waiver: fee.waiver || null, as_of: fee.cycle_label, source_url: fee.source_url,
      degree_ids: [it.degree_id], amount_international: fee.amount_international ?? null, ...chargeFor(fee, applicant),
    });
  }
  const list = [...charges.values()];
  const byCurrency = {};
  for (const c of list) {
    const t = (byCurrency[c.currency] ||= { max: 0, min: 0 });
    t.max += c.amount; t.min += c.min;
  }
  return { charges: list, totals: byCurrency, unknown_degree_ids: unknown, complete: unknown.length === 0 };
}
